// An optional duration from the env, given in seconds, as milliseconds. The
// fallback applies when the variable is unset, empty or not a non-negative
// number, so a missing or mistyped value never changes behaviour.
export const readEnvSecondsAsMs = (env, name, fallbackMs) => {
  const raw = env?.[name];
  const seconds = Number(raw);
  if (raw === undefined || String(raw).trim() === '' || !Number.isFinite(seconds) || seconds < 0) {
    return fallbackMs;
  }
  return seconds * 1000;
};
